// Google Adwords

export const adwordsFormFieldsCampaignName = {
  campaignName: {
    key: 'campaignName',
    type: 'text',
    label: 'Campaign Name',
    placeholder: '',
    required: true,
    requiredMessage: 'This field is required.',
    minLength: 3,
    minLengthMessage: 'Minimum 3 character allowed.',
    maxLength: 100,
    maxLengthMessage: 'Maximum 100 character allowed.',
    displayLayout: 'col-md-12',
    // labelLayout: 'col-md-12',
    tooltip: '<div> Campaign Plan Name </div>',
    // spaceNotAllowed: true
    // pattern: /^([a-zA-Z0-9&._@]+\s)*[a-zA-Z0-9&._@]$/,
    // pattern: /^[A-Za-z_-][A-Za-z0-9_-]*$/,
    // patternMessage: 'Campaign Name must start with a letter. Allowed characters are a-z & A-Z, 0-9,_,-'
  },
}

export const adwordsFormFields = {
  campaignName: {
    key: 'campaignName',
    type: 'text',
    // label: 'Campaign Name',
    placeholder: '',
    required: true,
    requiredMessage: 'This field is required.',
    minLength: 3,
    minLengthMessage: 'Minimum 3 character allowed.',
    maxLength: 100,
    maxLengthMessage: 'Maximum 100 character allowed.',
    displayLayout: 'col-md-12',
    // labelLayout: 'col-md-12',
    tooltip: '<div> Campaign Plan Name </div>',
    // spaceNotAllowed: true
    // pattern: /^([a-zA-Z0-9&._@]+\s)*[a-zA-Z0-9&._@]$/,
    // pattern: /^[A-Za-z_-][A-Za-z0-9_-]*$/,
    // patternMessage: 'Campaign Name must start with a letter. Allowed characters are a-z & A-Z, 0-9,_,-'
  },

  pacing: {
    key: 'pacing',
    //   label: 'Objective / Goal ',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    required: true,
    requiredMessage: 'This field is required.',
    valueKey: 'id',
    textKey: 'name',
  },

  duration: {
    key: 'duration',
    //   label: 'Objective / Goal ',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    required: true,
    requiredMessage: 'This field is required.',
    valueKey: 'id',
    textKey: 'name',
  },


  startDate: {
    key: 'startDate',
    //   label: 'Start Date',
    required: true,
    placeholder: 'DD/MM/YYYY',
    displayLayout: 'col-sm-12',
    requiredMessage: 'This field is required.',
  },
  endDate: {
    key: 'endDate',
    //   label: 'End Date',
    // label: 'End Date',
    required: true,
    // required: false,
    // placeholder: 'End Date',
    placeholder: 'DD/MM/YYYY',
    displayLayout: 'col-sm-12',
    requiredMessage: 'This field is required.',
  },



  budget: {
    key: 'budget',
    type: 'number',
    //   label: 'Budget / month ( $ )',
    placeholder: '',
    required: true,
    requiredMessage: 'This field is required.',
    // minLength : 0,
    // minLengthMessage: 'Minimum value is 500.',
    // maxLength: 100,
    // maxLengthMessage: 'maximum 100 characters allowed.',
    min: 1,
    max: 999999999999,
    upto4Digit: true,
    // upto2Digit: true,
    displayLayout: 'col-md-12',
    // labelLayout: 'pb-4',
    tooltip: '<div> Target Value </div>',
    // pattern: /^\d+(\.\d{1,2})?$/
  },




};

export const adwordsDisplayFormFields = {
  campaignName: {
    key: 'campaignName',
    type: 'text',
    // label: 'Campaign Name',
    placeholder: '',
    required: true,
    requiredMessage: 'This field is required.',
    minLength: 3,
    minLengthMessage: 'Minimum 3 character allowed.',
    maxLength: 100,
    maxLengthMessage: 'Maximum 100 character allowed.',
    displayLayout: 'col-md-12',
    // labelLayout: 'col-md-12',
    tooltip: '<div> Campaign Plan Name </div>',
    // spaceNotAllowed: true
    // pattern: /^([a-zA-Z0-9&._@]+\s)*[a-zA-Z0-9&._@]$/,
    // pattern: /^[A-Za-z_-][A-Za-z0-9_-]*$/,
    // patternMessage: 'Campaign Name must start with a letter. Allowed characters are a-z & A-Z, 0-9,_,-'
  },
  pacing: {
    key: 'pacing',
    //   label: 'Objective / Goal ',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    required: true,
    requiredMessage: 'This field is required.',
    valueKey: 'id',
    textKey: 'name',
  },

  duration: {
    key: 'duration',
    //   label: 'Objective / Goal ',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    required: true,
    requiredMessage: 'This field is required.',
    valueKey: 'id',
    textKey: 'name',
  },


  startDate: {
    key: 'startDate',
    //   label: 'Start Date',
    required: true,
    placeholder: 'DD/MM/YYYY',
    displayLayout: 'col-sm-12',
    requiredMessage: 'This field is required.',
  },
  endDate: {
    key: 'endDate',
    //   label: 'End Date',
    // label: 'End Date',
    required: true,
    // required: false,
    // placeholder: 'End Date',
    placeholder: 'DD/MM/YYYY',
    displayLayout: 'col-sm-12',
    requiredMessage: 'This field is required.',
  },

  budget: {
    key: 'budget',
    type: 'number',
    //   label: 'Budget / month ( $ )',
    placeholder: '',
    required: true,
    requiredMessage: 'This field is required.',
    // minLength : 0,
    // minLengthMessage: 'Minimum value is 500.',
    // maxLength: 100,
    // maxLengthMessage: 'maximum 100 characters allowed.',
    min: 1,
    max: 999999999999,
    upto4Digit: true,
    // upto2Digit: true,
    displayLayout: 'col-md-12',
    // labelLayout: 'pb-4',
    tooltip: '<div> Target Value </div>',
    // pattern: /^\d+(\.\d{1,2})?$/
  },
  frequencyCapForLevel: {
    key: 'frequencyCapForLevel',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    // required: true,
    requiredMessage: 'This field is required.',
    valueKey: 'id',
    textKey: 'name',
  },
  frequencyCapTo: {
    key: 'frequencyCapTo',
    type: 'number',
    placeholder: '',
    // required: true,
    requiredMessage: 'This field is required.',
    min: 1,
    max: 999,
    displayLayout: 'col-md-12',
    tooltip: '<div> Target Value </div>',
  },
  frequencyCapPerInterval: {
    key: 'frequencyCapPerInterval',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    // required: true,
    requiredMessage: 'This field is required.',
    valueKey: 'id',
    textKey: 'name',
  },
}


// facebook

export const facebookFormFieldsCampaignName = {
  campaignName: {
    key: 'campaignName',
    type: 'text',
    label: 'Campaign Name',
    placeholder: '',
    required: true,
    requiredMessage: 'This field is required.',
    minLength: 3,
    minLengthMessage: 'Minimum 3 character allowed.',
    maxLength: 100,
    maxLengthMessage: 'Maximum 100 character allowed.',
    displayLayout: 'col-md-12',
    // labelLayout: 'col-md-12',
    tooltip: '<div> Campaign Plan Name </div>',
    // spaceNotAllowed: true
    // pattern: /^([a-zA-Z0-9&._@]+\s)*[a-zA-Z0-9&._@]$/,
    // pattern: /^[A-Za-z_-][A-Za-z0-9_-]*$/,
    // patternMessage: 'Campaign Name must start with a letter. Allowed characters are a-z & A-Z, 0-9,_,-'
  },
}

export const facebookDisplayFormFields = {



  pacing: {
    key: 'pacing',
    //   label: 'Objective / Goal ',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    required: true,
    requiredMessage: 'This field is required.',
    valueKey: 'id',
    textKey: 'name',
  },

  duration: {
    key: 'duration',
    //   label: 'Objective / Goal ',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    required: true,
    requiredMessage: 'This field is required.',
    valueKey: 'id',
    textKey: 'name',
  },


  startDate: {
    key: 'startDate',
    //   label: 'Start Date',
    required: true,
    placeholder: 'DD/MM/YYYY',
    displayLayout: 'col-sm-12',
    requiredMessage: 'This field is required.',
  },
  endDate: {
    key: 'endDate',
    //   label: 'End Date',
    // label: 'End Date',
    required: true,
    // required: false,
    // placeholder: 'End Date',
    placeholder: 'DD/MM/YYYY',
    displayLayout: 'col-sm-12',
    requiredMessage: 'This field is required.',
  },

  budget: {
    key: 'budget',
    type: 'number',
    //   label: 'Budget / month ( $ )',
    placeholder: '',
    required: true,
    requiredMessage: 'This field is required.',
    // minLength : 0,
    // minLengthMessage: 'Minimum value is 500.',
    // maxLength: 100,
    // maxLengthMessage: 'maximum 100 characters allowed.',
    min: 1,
    max: 999999999999,
    upto4Digit: true,
    // upto2Digit: true,
    displayLayout: 'col-md-12',
    // labelLayout: 'pb-4',
    tooltip: '<div> Target Value </div>',
    // pattern: /^\d+(\.\d{1,2})?$/
  },
};

export const facebookVideoFormFields =
{

  pacing: {
    key: 'pacing',
    //   label: 'Objective / Goal ',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    required: true,
    requiredMessage: 'This field is required.',
    valueKey: 'id',
    textKey: 'name',
  },

  duration: {
    key: 'duration',
    //   label: 'Objective / Goal ',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    required: true,
    requiredMessage: 'This field is required.',
    valueKey: 'id',
    textKey: 'name',
  },


  startDate: {
    key: 'startDate',
    //   label: 'Start Date',
    required: true,
    placeholder: 'DD/MM/YYYY',
    displayLayout: 'col-sm-12',
    requiredMessage: 'This field is required.',
  },
  endDate: {
    key: 'endDate',
    //   label: 'End Date',
    // label: 'End Date',
    required: true,
    // required: false,
    // placeholder: 'End Date',
    placeholder: 'DD/MM/YYYY',
    displayLayout: 'col-sm-12',
    requiredMessage: 'This field is required.',
  },

  budget: {
    key: 'budget',
    type: 'number',
    //   label: 'Budget / month ( $ )',
    placeholder: '',
    required: true,
    requiredMessage: 'This field is required.',
    // minLength : 0,
    // minLengthMessage: 'Minimum value is 500.',
    // maxLength: 100,
    // maxLengthMessage: 'maximum 100 characters allowed.',
    min: 1,
    max: 999999999999,
    upto4Digit: true,
    // upto2Digit: true,
    displayLayout: 'col-md-12',
    // labelLayout: 'pb-4',
    tooltip: '<div> Target Value </div>',
    // pattern: /^\d+(\.\d{1,2})?$/
  },
}

// DV360

export const dv360FormFieldsCampaignName = {
  campaignName: {
    key: 'campaignName',
    type: 'text',
    label: 'Campaign Name',
    placeholder: '',
    required: true,
    requiredMessage: 'This field is required.',
    minLength: 3,
    minLengthMessage: 'Minimum 3 character allowed.',
    maxLength: 100,
    maxLengthMessage: 'Maximum 100 character allowed.',
    displayLayout: 'col-md-12',
    // labelLayout: 'col-md-12',
    tooltip: '<div> Campaign Plan Name </div>',
    // spaceNotAllowed: true
    // pattern: /^([a-zA-Z0-9&._@]+\s)*[a-zA-Z0-9&._@]$/,
    // pattern: /^[A-Za-z_-][A-Za-z0-9_-]*$/,
    // patternMessage: 'Campaign Name must start with a letter. Allowed characters are a-z & A-Z, 0-9,_,-'
  },
}

export const dv360VideoFormFields = {
  pacing: {
    key: 'pacing',
    //   label: 'Objective / Goal ',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    required: true,
    requiredMessage: 'This field is required.',
    valueKey: 'id',
    textKey: 'name',
  },

  duration: {
    key: 'duration',
    //   label: 'Objective / Goal ',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    required: true,
    requiredMessage: 'This field is required.',
    valueKey: 'id',
    textKey: 'name',
  },


  startDate: {
    key: 'startDate',
    //   label: 'Start Date',
    required: true,
    placeholder: 'DD/MM/YYYY',
    displayLayout: 'col-sm-12',
    requiredMessage: 'This field is required.',
  },
  endDate: {
    key: 'endDate',
    //   label: 'End Date',
    // label: 'End Date',
    required: true,
    // required: false,
    // placeholder: 'End Date',
    placeholder: 'DD/MM/YYYY',
    displayLayout: 'col-sm-12',
    requiredMessage: 'This field is required.',
  },



  budget: {
    key: 'budget',
    type: 'number',
    //   label: 'Budget / month ( $ )',
    placeholder: '',
    required: true,
    requiredMessage: 'This field is required.',
    // minLength : 0,
    // minLengthMessage: 'Minimum value is 500.',
    // maxLength: 100,
    // maxLengthMessage: 'maximum 100 characters allowed.',
    min: 1,
    max: 999999999999,
    upto4Digit: true,
    // upto2Digit: true,
    displayLayout: 'col-md-12',
    // labelLayout: 'pb-4',
    tooltip: '<div> Target Value </div>',
    // pattern: /^\d+(\.\d{1,2})?$/
  },

  frequencyCapTime: {
    key: 'frequencyCapTime',
    type: 'number',
    placeholder: '',
    // required: true,
    requiredMessage: 'This field is required.',
    min: 1,
    max: 999,
    displayLayout: 'col-md-12',
    tooltip: '<div> Target Value </div>',
  },
  frequencyCapTo: {
    key: 'frequencyCapTo',
    type: 'number',
    placeholder: '',
    // required: true,
    requiredMessage: 'This field is required.',
    min: 1,
    max: 999,
    displayLayout: 'col-md-12',
    tooltip: '<div> Target Value </div>',
  },
  frequencyCapPerInterval: {
    key: 'frequencyCapPerInterval',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    // required: true,
    requiredMessage: 'This field is required.',
    valueKey: 'id',
    textKey: 'name',
  },




};

export const dv360DisplayFormFields = {
  pacing: {
    key: 'pacing',
    //   label: 'Objective / Goal ',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    required: true,
    requiredMessage: 'This field is required.',
    valueKey: 'id',
    textKey: 'name',
  },

  duration: {
    key: 'duration',
    //   label: 'Objective / Goal ',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    required: true,
    requiredMessage: 'This field is required.',
    valueKey: 'id',
    textKey: 'name',
  },


  startDate: {
    key: 'startDate',
    //   label: 'Start Date',
    required: true,
    placeholder: 'DD/MM/YYYY',
    displayLayout: 'col-sm-12',
    requiredMessage: 'This field is required.',
  },
  endDate: {
    key: 'endDate',
    //   label: 'End Date',
    // label: 'End Date',
    required: true,
    // required: false,
    // placeholder: 'End Date',
    placeholder: 'DD/MM/YYYY',
    displayLayout: 'col-sm-12',
    requiredMessage: 'This field is required.',
  },

  budget: {
    key: 'budget',
    type: 'number',
    //   label: 'Budget / month ( $ )',
    placeholder: '',
    required: true,
    requiredMessage: 'This field is required.',
    // minLength : 0,
    // minLengthMessage: 'Minimum value is 500.',
    // maxLength: 100,
    // maxLengthMessage: 'maximum 100 characters allowed.',
    min: 1,
    max: 999999999999,
    upto4Digit: true,
    // upto2Digit: true,
    displayLayout: 'col-md-12',
    // labelLayout: 'pb-4',
    tooltip: '<div> Target Value </div>',
    // pattern: /^\d+(\.\d{1,2})?$/
  },
  frequencyCapTime: {
    key: 'frequencyCapTime',
    type: 'number',
    placeholder: '',
    // required: true,
    requiredMessage: 'This field is required.',
    min: 1,
    max: 999,
    displayLayout: 'col-md-12',
    tooltip: '<div> Target Value </div>',
  },
  frequencyCapTo: {
    key: 'frequencyCapTo',
    type: 'number',
    placeholder: '',
    // required: true,
    requiredMessage: 'This field is required.',
    min: 1,
    max: 999,
    displayLayout: 'col-md-12',
    tooltip: '<div> Target Value </div>',
  },
  frequencyCapPerInterval: {
    key: 'frequencyCapPerInterval',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    // required: true,
    requiredMessage: 'This field is required.',
    valueKey: 'id',
    textKey: 'name',
  },
}

// TIKTOK

export const tiktokFormFieldsCampaignName = {
  campaignName: {
    key: 'campaignName',
    type: 'text',
    label: 'Campaign Name',
    placeholder: '',
    required: true,
    requiredMessage: 'This field is required.',
    minLength: 3,
    minLengthMessage: 'Minimum 3 character allowed.',
    maxLength: 100,
    maxLengthMessage: 'Maximum 100 character allowed.',
    displayLayout: 'col-md-12',
    // labelLayout: 'col-md-12',
    tooltip: '<div> Campaign Plan Name </div>',
    // spaceNotAllowed: true
    // pattern: /^([a-zA-Z0-9&._@]+\s)*[a-zA-Z0-9&._@]$/,
    // pattern: /^[A-Za-z_-][A-Za-z0-9_-]*$/,
    // patternMessage: 'Campaign Name must start with a letter. Allowed characters are a-z & A-Z, 0-9,_,-'
  },
}

export const tiktokVideoFormFields =
{

  pacing: {
    key: 'pacing',
    //   label: 'Objective / Goal ',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    required: true,
    requiredMessage: 'This field is required.',
    valueKey: 'id',
    textKey: 'name',
  },

  duration: {
    key: 'duration',
    //   label: 'Objective / Goal ',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    required: true,
    requiredMessage: 'This field is required.',
    valueKey: 'id',
    textKey: 'name',
  },


  startDate: {
    key: 'startDate',
    //   label: 'Start Date',
    required: true,
    placeholder: 'DD/MM/YYYY',
    displayLayout: 'col-sm-12',
    requiredMessage: 'This field is required.',
  },
  endDate: {
    key: 'endDate',
    //   label: 'End Date',
    // label: 'End Date',
    required: true,
    // required: false,
    // placeholder: 'End Date',
    placeholder: 'DD/MM/YYYY',
    displayLayout: 'col-sm-12',
    requiredMessage: 'This field is required.',
  },

  budget: {
    key: 'budget',
    type: 'number',
    //   label: 'Budget / month ( $ )',
    placeholder: '',
    required: true,
    requiredMessage: 'This field is required.',
    // minLength : 0,
    // minLengthMessage: 'Minimum value is 500.',
    // maxLength: 100,
    // maxLengthMessage: 'maximum 100 characters allowed.',
    min: 1,
    max: 999999999999,
    upto4Digit: true,
    // upto2Digit: true,
    displayLayout: 'col-md-12',
    // labelLayout: 'pb-4',
    tooltip: '<div> Target Value </div>',
    // pattern: /^\d+(\.\d{1,2})?$/
  },
}

//ION
export const ionDisplayFormFields = {

  campaignName: {
    key: 'campaignName',
    type: 'text',
    // label: 'Campaign Name',
    placeholder: '',
    required: true,
    requiredMessage: 'This field is required.',
    minLength: 3,
    minLengthMessage: 'Minimum 3 character allowed.',
    maxLength: 100,
    maxLengthMessage: 'Maximum 100 character allowed.',
    displayLayout: 'col-md-12',
    // labelLayout: 'col-md-12',
    tooltip: '<div> Campaign Plan Name </div>',
    // spaceNotAllowed: true
    // pattern: /^([a-zA-Z0-9&._@]+\s)*[a-zA-Z0-9&._@]$/,
    // pattern: /^[A-Za-z_-][A-Za-z0-9_-]*$/,
    // patternMessage: 'Campaign Name must start with a letter. Allowed characters are a-z & A-Z, 0-9,_,-'
  },
  pacing: {
    key: 'pacing',
    //   label: 'Objective / Goal ',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    required: true,
    requiredMessage: 'This field is required.',
    valueKey: 'id',
    textKey: 'name',
  },

  duration: {
    key: 'duration',
    //   label: 'Objective / Goal ',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    required: true,
    requiredMessage: 'This field is required.',
    valueKey: 'id',
    textKey: 'name',
  },


  startDate: {
    key: 'startDate',
    //   label: 'Start Date',
    required: true,
    placeholder: 'DD/MM/YYYY',
    displayLayout: 'col-sm-12',
    requiredMessage: 'This field is required.',
  },
  endDate: {
    key: 'endDate',
    //   label: 'End Date',
    // label: 'End Date',
    required: true,
    // required: false,
    // placeholder: 'End Date',
    placeholder: 'DD/MM/YYYY',
    displayLayout: 'col-sm-12',
    requiredMessage: 'This field is required.',
  },

  budget: {
    key: 'budget',
    type: 'number',
    //   label: 'Budget / month ( $ )',
    placeholder: '',
    required: true,
    requiredMessage: 'This field is required.',
    // minLength : 0,
    // minLengthMessage: 'Minimum value is 500.',
    // maxLength: 100,
    // maxLengthMessage: 'maximum 100 characters allowed.',
    min: 1,
    max: 999999999999,
    upto4Digit: true,
    // upto2Digit: true,
    displayLayout: 'col-md-12',
    // labelLayout: 'pb-4',
    tooltip: '<div> Target Value </div>',
    // pattern: /^\d+(\.\d{1,2})?$/
  },
  frequencyCapTime: {
    key: 'frequencyCapTime',
    // type: 'number',
    placeholder: '',
    // required: true,
    requiredMessage: 'This field is required.',
    min: 1,
    max: 99999999,
    displayLayout: 'col-md-12',
    tooltip: '<div> Target Value </div>',
    placeholder: '--Select--',
    valueKey: 'id',
    textKey: 'name',
  },
  frequencyCapTo: {
    key: 'frequencyCapTo',
    type: 'number',
    placeholder: '',
    // required: true,
    requiredMessage: 'This field is required.',
    min: 0,
    max: 99999999,
    displayLayout: 'col-md-12',
    tooltip: '<div> Target Value </div>',
  },
  frequencyCapPerInterval: {
    key: 'frequencyCapPerInterval',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    // required: true,
    requiredMessage: 'This field is required.',
    valueKey: 'id',
    textKey: 'name',
  },
};

export const ionVideoFormFields =
{
  campaignName: {
    key: 'campaignName',
    type: 'text',
    // label: 'Campaign Name',
    placeholder: '',
    required: true,
    requiredMessage: 'This field is required.',
    minLength: 3,
    minLengthMessage: 'Minimum 3 character allowed.',
    maxLength: 100,
    maxLengthMessage: 'Maximum 100 character allowed.',
    displayLayout: 'col-md-12',
    // labelLayout: 'col-md-12',
    tooltip: '<div> Campaign Plan Name </div>',
    // spaceNotAllowed: true
    // pattern: /^([a-zA-Z0-9&._@]+\s)*[a-zA-Z0-9&._@]$/,
    // pattern: /^[A-Za-z_-][A-Za-z0-9_-]*$/,
    // patternMessage: 'Campaign Name must start with a letter. Allowed characters are a-z & A-Z, 0-9,_,-'
  },

  pacing: {
    key: 'pacing',
    //   label: 'Objective / Goal ',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    required: true,
    requiredMessage: 'This field is required.',
    valueKey: 'id',
    textKey: 'name',
  },

  duration: {
    key: 'duration',
    //   label: 'Objective / Goal ',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    required: true,
    requiredMessage: 'This field is required.',
    valueKey: 'id',
    textKey: 'name',
  },


  startDate: {
    key: 'startDate',
    //   label: 'Start Date',
    required: true,
    placeholder: 'DD/MM/YYYY',
    displayLayout: 'col-sm-12',
    requiredMessage: 'This field is required.',
  },
  endDate: {
    key: 'endDate',
    //   label: 'End Date',
    // label: 'End Date',
    required: true,
    // required: false,
    // placeholder: 'End Date',
    placeholder: 'DD/MM/YYYY',
    displayLayout: 'col-sm-12',
    requiredMessage: 'This field is required.',
  },

  budget: {
    key: 'budget',
    type: 'number',
    //   label: 'Budget / month ( $ )',
    placeholder: '',
    required: true,
    requiredMessage: 'This field is required.',
    // minLength : 0,
    // minLengthMessage: 'Minimum value is 500.',
    // maxLength: 100,
    // maxLengthMessage: 'maximum 100 characters allowed.',
    min: 1,
    max: 999999999999,
    upto4Digit: true,
    // upto2Digit: true,
    displayLayout: 'col-md-12',
    // labelLayout: 'pb-4',
    tooltip: '<div> Target Value </div>',
    // pattern: /^\d+(\.\d{1,2})?$/
  },
  frequencyCapTime: {
    key: 'frequencyCapTime',
    // type: 'number',
    placeholder: '',
    // required: true,
    requiredMessage: 'This field is required.',
    min: 1,
    max: 99999999,
    displayLayout: 'col-md-12',
    tooltip: '<div> Target Value </div>',
    placeholder: '--Select--',
    valueKey: 'id',
    textKey: 'name',
  },
  frequencyCapTo: {
    key: 'frequencyCapTo',
    type: 'number',
    placeholder: '',
    // required: true,
    requiredMessage: 'This field is required.',
    min: 0,
    max: 99999999,
    displayLayout: 'col-md-12',
    tooltip: '<div> Target Value </div>',
  },
  frequencyCapPerInterval: {
    key: 'frequencyCapPerInterval',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    // required: true,
    requiredMessage: 'This field is required.',
    valueKey: 'id',
    textKey: 'name',
  },
}

//Vi Ads
export const viAdsDisplayFormFields = {

  campaignName: {
    key: 'campaignName',
    type: 'text',
    // label: 'Campaign Name',
    placeholder: '',
    required: true,
    requiredMessage: 'This field is required.',
    minLength: 3,
    minLengthMessage: 'Minimum 3 character allowed.',
    maxLength: 100,
    maxLengthMessage: 'Maximum 100 character allowed.',
    displayLayout: 'col-md-12',
    // labelLayout: 'col-md-12',
    tooltip: '<div> Campaign Plan Name </div>',
    // spaceNotAllowed: true
    // pattern: /^([a-zA-Z0-9&._@]+\s)*[a-zA-Z0-9&._@]$/,
    // pattern: /^[A-Za-z_-][A-Za-z0-9_-]*$/,
    // patternMessage: 'Campaign Name must start with a letter. Allowed characters are a-z & A-Z, 0-9,_,-'
  },
  pacing: {
    key: 'pacing',
    //   label: 'Objective / Goal ',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    required: true,
    requiredMessage: 'This field is required.',
    valueKey: 'id',
    textKey: 'name',
  },

  duration: {
    key: 'duration',
    //   label: 'Objective / Goal ',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    required: true,
    requiredMessage: 'This field is required.',
    valueKey: 'id',
    textKey: 'name',
  },


  startDate: {
    key: 'startDate',
    //   label: 'Start Date',
    required: true,
    placeholder: 'DD/MM/YYYY',
    displayLayout: 'col-sm-12',
    requiredMessage: 'This field is required.',
  },
  endDate: {
    key: 'endDate',
    //   label: 'End Date',
    // label: 'End Date',
    required: true,
    // required: false,
    // placeholder: 'End Date',
    placeholder: 'DD/MM/YYYY',
    displayLayout: 'col-sm-12',
    requiredMessage: 'This field is required.',
  },

  budget: {
    key: 'budget',
    type: 'number',
    //   label: 'Budget / month ( $ )',
    placeholder: '',
    required: true,
    requiredMessage: 'This field is required.',
    // minLength : 0,
    // minLengthMessage: 'Minimum value is 500.',
    // maxLength: 100,
    // maxLengthMessage: 'maximum 100 characters allowed.',
    min: 1,
    // upto2Digit: true,
    displayLayout: 'col-md-12',
    // labelLayout: 'pb-4',
    tooltip: '<div> Target Value </div>',
    // pattern: /^\d+(\.\d{1,2})?$/
  },
  frequencyCapTime: {
    key: 'frequencyCapTime',
    // type: 'number',
    placeholder: '',
    // required: true,
    requiredMessage: 'This field is required.',
    min: 1,
    max: 99999999,
    displayLayout: 'col-md-12',
    tooltip: '<div> Target Value </div>',
    placeholder: '--Select--',
    valueKey: 'id',
    textKey: 'name',
  },
  frequencyCapTo: {
    key: 'frequencyCapTo',
    type: 'number',
    placeholder: '',
    // required: true,
    requiredMessage: 'This field is required.',
    min: 0,
    max: 99999999,
    displayLayout: 'col-md-12',
    tooltip: '<div> Target Value </div>',
  },
  frequencyCapPerInterval: {
    key: 'frequencyCapPerInterval',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    // required: true,
    requiredMessage: 'This field is required.',
    valueKey: 'id',
    textKey: 'name',
  },
};

export const viAdsVideoFormFields =
{
  campaignName: {
    key: 'campaignName',
    type: 'text',
    // label: 'Campaign Name',
    placeholder: '',
    required: true,
    requiredMessage: 'This field is required.',
    minLength: 3,
    minLengthMessage: 'Minimum 3 character allowed.',
    maxLength: 100,
    maxLengthMessage: 'Maximum 100 character allowed.',
    displayLayout: 'col-md-12',
    // labelLayout: 'col-md-12',
    tooltip: '<div> Campaign Plan Name </div>',
    // spaceNotAllowed: true
    // pattern: /^([a-zA-Z0-9&._@]+\s)*[a-zA-Z0-9&._@]$/,
    // pattern: /^[A-Za-z_-][A-Za-z0-9_-]*$/,
    // patternMessage: 'Campaign Name must start with a letter. Allowed characters are a-z & A-Z, 0-9,_,-'
  },

  pacing: {
    key: 'pacing',
    //   label: 'Objective / Goal ',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    required: true,
    requiredMessage: 'This field is required.',
    valueKey: 'id',
    textKey: 'name',
  },

  duration: {
    key: 'duration',
    //   label: 'Objective / Goal ',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    required: true,
    requiredMessage: 'This field is required.',
    valueKey: 'id',
    textKey: 'name',
  },


  startDate: {
    key: 'startDate',
    //   label: 'Start Date',
    required: true,
    placeholder: 'DD/MM/YYYY',
    displayLayout: 'col-sm-12',
    requiredMessage: 'This field is required.',
  },
  endDate: {
    key: 'endDate',
    //   label: 'End Date',
    // label: 'End Date',
    required: true,
    // required: false,
    // placeholder: 'End Date',
    placeholder: 'DD/MM/YYYY',
    displayLayout: 'col-sm-12',
    requiredMessage: 'This field is required.',
  },

  budget: {
    key: 'budget',
    type: 'number',
    //   label: 'Budget / month ( $ )',
    placeholder: '',
    required: true,
    requiredMessage: 'This field is required.',
    // minLength : 0,
    // minLengthMessage: 'Minimum value is 500.',
    // maxLength: 100,
    // maxLengthMessage: 'maximum 100 characters allowed.',
    min: 1,
    // upto2Digit: true,
    displayLayout: 'col-md-12',
    // labelLayout: 'pb-4',
    tooltip: '<div> Target Value </div>',
    // pattern: /^\d+(\.\d{1,2})?$/
  },
  frequencyCapTime: {
    key: 'frequencyCapTime',
    // type: 'number',
    placeholder: '',
    // required: true,
    requiredMessage: 'This field is required.',
    min: 1,
    max: 99999999,
    displayLayout: 'col-md-12',
    tooltip: '<div> Target Value </div>',
    placeholder: '--Select--',
    valueKey: 'id',
    textKey: 'name',
  },
  frequencyCapTo: {
    key: 'frequencyCapTo',
    type: 'number',
    placeholder: '',
    // required: true,
    requiredMessage: 'This field is required.',
    min: 0,
    max: 99999999,
    displayLayout: 'col-md-12',
    tooltip: '<div> Target Value </div>',
  },
  frequencyCapPerInterval: {
    key: 'frequencyCapPerInterval',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    // required: true,
    requiredMessage: 'This field is required.',
    valueKey: 'id',
    textKey: 'name',
  },
}
